module.exports = __webpack_public_path__ + "img/wode.aeb5c5a0.svg";